import { footerLinks } from '@/mocks/homeContent';

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-secondary-100">
      <div className="mx-auto max-w-[1240px] px-4 pb-8 pt-12 md:px-6">
        <div className="grid gap-8 md:grid-cols-[1.4fr_2fr]">
          {/* brand block */}
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-accent-500 font-label text-2xl text-secondary-950">9</span>
              <span className="leading-none">
                <span className="block font-heading text-2xl font-black tracking-tight text-secondary-50">
                  黑料<span className="text-accent-400">网</span>
                </span>
                <span className="mt-1 block text-[11px] tracking-widest text-secondary-300/80">分类专区 · 专题整理</span>
              </span>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-6 text-secondary-200/80">
              娱乐黑料、网红黑料、事件专区与专题话题按类整理，黑料盘点定期归档。理性吃瓜，求真有据，是本站的第一条规则。
            </p>
            <div className="mt-4 inline-flex items-center gap-2 rounded-md bg-secondary-800 px-3 py-2 text-xs text-secondary-100">
              <i className="ri-verified-badge-line flex h-4 w-4 items-center justify-center text-accent-400" />素材均分级核实 · 存疑内容不混入实锤
            </div>
          </div>

          {/* link columns */}
          <div className="grid grid-cols-2 gap-6 sm:grid-cols-3">
            {footerLinks.map((g) => (
              <div key={g.group}>
                <h4 className="mb-3 text-sm font-bold text-secondary-50">{g.group}</h4>
                <ul className="space-y-2.5">
                  {g.items.map((it) => (
                    <li key={it}>
                      <a
                        href="#top"
                        onClick={(e) => e.preventDefault()}
                        className="flex items-center gap-1.5 text-sm text-secondary-200/80 transition hover:text-accent-300"
                      >
                        <i className="ri-arrow-right-s-line flex h-4 w-4 items-center justify-center text-secondary-400" />{it}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        {/* disclaimer */}
        <div className="mt-10 rounded-lg bg-secondary-800/60 p-4">
          <p className="flex items-start gap-2 text-xs leading-5 text-secondary-200/75">
            <i className="ri-alert-line mt-0.5 flex h-4 w-4 shrink-0 items-center justify-center text-accent-400" />
            <span>
              本页所展示为站内内容整理与讨论框架的静态示例，不指向任何真实个人或机构。请以官方与权威信源为准，理性看待网络信息；涉及个人权益的异议，欢迎通过「纠错与异议」通道反馈，我们会在核实后处理。
            </span>
          </p>
        </div>

        {/* copyright */}
        <div className="mt-8 flex flex-col items-center justify-between gap-3 border-t border-secondary-700/60 pt-6 sm:flex-row">
          <p className="flex flex-wrap items-center justify-center gap-2 text-xs text-secondary-300/70">
            <span>© 2026 9黑料网 · 分类专区聚合站</span>
            <span className="hidden sm:inline">|</span>
            <span>黑料盘点 · 事件专区 · 专题话题</span>
          </p>
          <div className="flex items-center gap-3">
            <a href="#top" className="flex items-center gap-1 whitespace-nowrap text-xs text-secondary-200/80 transition hover:text-accent-300">
              <i className="ri-arrow-up-line flex h-4 w-4 items-center justify-center" />回到顶部
            </a>
            <a href="#faq" className="flex items-center gap-1 whitespace-nowrap text-xs text-secondary-200/80 transition hover:text-accent-300">
              纠错反馈 <i className="ri-mail-send-line flex h-4 w-4 items-center justify-center" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}